
<div class="row" style="min-height: 13%;">
  <div class="col-12 p-0">
    <app-headernew></app-headernew>
  </div>
</div>

<div class="row ">
  <div class="col-12 p-0" id="main-content">
    <app-content></app-content>
  </div>
</div>

<div class="row">
  <div class="col-12 p-0" id="footer">
    <app-footernew></app-footernew>
  </div>
</div>
